import { useRef, useState } from 'react';

import { fetchRecipeList } from 'src/services/recipe/search-api';
import { type RecipeSearchInput, type RecipeSearchOutput } from 'src/types/backend';

// ----------------------------------------------------------------------
// ----------------------------------------------------------------------

export function useRecipeListApi(defaultRecipes: RecipeSearchOutput | null = null) {
  const isLoading = useRef(false);
  const [recipeList, setRecipeList] = useState<RecipeSearchOutput | null>(defaultRecipes);

  const loadRecipeList = async (data: RecipeSearchInput) => {
    if (isLoading.current) {
      return;
    }

    isLoading.current = true;
    const listResponse = await fetchRecipeList(data);
    setRecipeList(listResponse);
    isLoading.current = false;
  };

  return {
    recipeList,
    setRecipeList,
    loadRecipeList,
    isLoading,
  };
}

